<template>
  <div class="popup-main">
    <el-dialog
      :title="detailId ? '编辑场地' : '新增场地'"
      width="800px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <div>
        <div v-if="loaded">
          <e-form
            ref="refForm"
            :config="formConfig"
            :column="formColumn"
            :rules="formRules"
            :data.sync="selfData"
          />
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    parentId: {
      type: [Number, String],
      required: true
    },
    parentName: {
      type: String,
      required: true
    },
    detailId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      loaded: false,
      selfShow: false,
      selfData: {
        parent_id: '',
        parent_name: '',
        id: '',
        type: '',
        area_size: '',
        use_type: '',
        start_date: '',
        limit_count: '',
        limit_unit: '年',
        rent_count: '',
        rent_unit: '月',
        contract_file: [],
        remark: '',
        status: true
      },
      formConfig: {
        inline: false,
        width: '100%'
      },
      formColumn: [
        {
          type: 'text',
          title: '所属工作地点',
          field: 'parent_name',
          disabled: true
        },
        {
          type: 'select',
          title: '场地类型',
          field: 'type',
          options: [
            {
              key: '厂房',
              val: '厂房'
            },
            {
              key: '住宅',
              val: '住宅'
            },
            {
              key: '写字楼',
              val: '写字楼'
            },
            {
              key: '铺面',
              val: '铺面'
            }
          ]
        },
        {
          type: 'number',
          title: '面积大小',
          field: 'area_size',
          suffix: 'm²'
        },
        {
          type: 'select',
          title: '使用方式',
          field: 'use_type',
          options: [
            {
              key: '自有',
              val: '自有'
            },
            {
              key: '租用',
              val: '租用'
            }
          ]
        },
        {
          type: 'number',
          title: '租约期限',
          field: 'limit_count',
          selectField: 'limit_unit',
          selectOptions: [
            {
              key: '年',
              val: '年'
            },
            {
              key: '月',
              val: '月'
            },
            {
              key: '日',
              val: '日'
            }
          ]
        },
        {
          type: 'number',
          title: '租金',
          field: 'rent_count',
          selectField: 'rent_unit',
          selectOptions: [
            {
              key: '年',
              val: '年'
            },
            {
              key: '月',
              val: '月'
            },
            {
              key: '日',
              val: '日'
            }
          ]
        },
        {
          type: 'date',
          title: '起租日期',
          field: 'start_date'
        },
        {
          type: 'upload_file',
          title: '租约附件',
          field: 'contract_file'
        },
        {
          type: 'text',
          title: '备注',
          field: 'remark'
        },
        {
          type: 'switch',
          title: '状态',
          field: 'status'
        }
      ],
      formRules: {
        name: [{ required: true, message: '请输入场地名称' }]
      }
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    if (this.detailId) {
      this.getDetailData()
    } else {
      this.initSelfData()
    }
  },
  methods: {
    // 获取详情数据
    async getDetailData() {
      this.loaded = false
      await this.$api({
        method: 'get',
        url: '/admin/gcvip/changdi2/detail',
        params: {
          id: this.detailId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data.data)
          this.selfData = result
        }
      })
      this.loaded = true
    },
    // 初始化数据
    initSelfData() {
      this.loaded = false
      this.selfData.parent_id = this.parentId
      this.selfData.parent_name = this.parentName
      this.loaded = true
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$refs.refForm.$refs.refForm.validate((valid) => {
        if (valid) {
          this.$api({
            method: 'post',
            url: '/admin/gcvip/changdi2/saveOrUpdate',
            data: {
              form_data: this.selfData
            }
          })
            .then((res) => {
              if (res.data.state === 'ok') {
                this.popupCancel()
                this.$emit('success')
                this.$message.success('保存成功')
              }
            })
            .catch(() => {})
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
